var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[_vm._t("default"),_c('v-navigation-drawer',{attrs:{"absolute":"","temporary":"","right":"","width":"100%"},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('order-summary-sale')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }